// slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isAuthenticated: true,
  error: null,
  user: true,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = action.payload
    },
    nameSuccess: (state, action) => {
      state.user = action.payload
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = false
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const { loginSuccess, nameSuccess, logout, clearError } =
  authSlice.actions

export default authSlice.reducer
